/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_SuccessInputs */

const fr_membership_freeze_success = /** @type {(inputs: Membership_Freeze_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre abonnement est mis en pause.`)
};

/**

* @param {Membership_Freeze_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_success = /** @type {((inputs?: Membership_Freeze_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_success(inputs)
});